import { ProjectDocumentDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProjectDocumentService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getProjectDocument(): Observable<ProjectDocumentDto[]> {
    return this.http.get<ProjectDocumentDto[]>(this.url + 'project-document');
  }

  createProjectDocument(
    data: ProjectDocumentDto[]
  ): Observable<ProjectDocumentDto[]> {
    return this.http.post<ProjectDocumentDto[]>(
      this.url + 'project-document',
      data
    );
  }
  getSingleProjectDocument(id: string): Observable<any> {
    return this.http.get(this.url + 'project-document/' + id);
  }

  updateProjectDocument(
    data: ProjectDocumentDto[]
  ): Observable<ProjectDocumentDto[]> {
    return this.http.post<ProjectDocumentDto[]>(
      this.url + 'project-document/update',
      data
    );
  }

  deleteProjectDocument(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('project-document', ids.join(', '));
    return this.http.delete(this.url + 'project-document', httpOptions);
  }
}
